import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImgOne from "../../images/business-plan-workshop/1.png";
import BgImgTwo from "../../images/business-plan-workshop/2.png";
import BgImgThree from "../../images/business-plan-workshop/3.png";
import BgImgFour from "../../images/business-plan-workshop/4.png";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link } from "gatsby";



function NextGen({ handleShow }) {
  const [swiper, setSwiper] = React.useState();
  const prevRef = React.useRef();
  const nextRef = React.useRef();

  React.useEffect(() => {
    if (swiper) {
      console.log("Swiper instance:", swiper);
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);
  return (
    <section className="tekrevol__nextgen workshop-why overflow-x-hidden p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="example example-bottom" data-text="Workshop">
              <h2>Why Attend This Workshop?</h2>
            </div>
          </Col>

          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              // navigation={{
              // prevEl: prevRef?.current,
              // nextEl: nextRef?.current,
              // }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              pagination={{ clickable: true }}
              onSwiper={setSwiper}
              onSlideChange={() => console.log("slide change")}
              className="carosal_nextgen"
            >
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgOne})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">
                      Craft a Winning Business Plan
                      <br className="d-lg-block d-none" />
                      <span></span>
                    </h3>
                    <p>
                      Discover step-by-step strategies for building a plan that
                      attracts investors and drives growth.
                    </p>
                    <Link
                      href="https://www.tekrevol.com/blogs/business-plan-workshop-registration/"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Claim Your Seat Today
                    </Link>
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Claim Your Seat Today
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgTwo})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">
                      Actionable Templates Provided
                      <br className="d-lg-block d-none" />
                      <span></span>
                    </h3>
                    <p>
                      Receive a ready-to-use business plan template to simplify
                      your planning process.
                    </p>
                    <Link
                      href="https://www.tekrevol.com/blogs/business-plan-workshop-registration/"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Claim Your Seat Today
                    </Link>
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Claim Your Seat Today
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgThree})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">
                      Insights from an Industry Veteran{" "}
                      <br className="d-lg-block d-none" />
                      <span></span>
                    </h3>
                    <p>
                      Get real-world advice from Irfan ul Haq, a business leader
                      with over two decades of experience.
                    </p>
                    <Link
                      href="https://www.tekrevol.com/blogs/business-plan-workshop-registration/"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Claim Your Seat Today
                    </Link>
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Claim Your Seat Today
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="nextgen-item"
                  style={{ backgroundImage: `url(${BgImgFour})` }}
                >
                  <div className="nextgen-content">
                    <h3 className="title">
                      Live Q&A Session
                      <br className="d-lg-block d-none" />
                      <span></span>
                    </h3>
                    <p>
                      Engage with the expert and get your questions answered
                      directly.
                    </p>
                    <Link
                      href="https://www.tekrevol.com/blogs/business-plan-workshop-registration/"
                      className="btn-pri"
                      aria-label="Transform Data Strategy for Gen AI"
                    >
                      Claim Your Seat Today
                    </Link>
                    {/* <span className="btn-pri" onClick={handleShow}>
                      Claim Your Seat Today
                    </span> */}
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default NextGen;
